<template>
    <div class="main-content detail people-detail">
        <div class="container">
            <div class="events-group-header no-border">
                <div class="events-group-header-icon"><span>M</span></div>
                Main info
            </div>
            <div class="div" v-if="!person_save_btn_loading">
                <div class="form-container">
                    <div class="form-wrapper">
                        <div class="form-row">
                            <div class="form-hor">
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('first_name')"
                                    :value="person.first_name"
                                    :required="true"
                                    limit="60"
                                    hint="Hint! Max 60 characters"
                                    :name_capitalization="true"
                                    error_msg="Error! This field is mandatory"
                                    name="first_name"
                                    label="First name"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('last_name')"
                                    :value="person.last_name"
                                    :required="true"
                                    limit="60"
                                    hint="Hint! Max 60 characters"
                                    :capitalize="true"
                                    error_msg="Error! This field is mandatory"
                                    name="last_name"
                                    label="Last name"
                                ></custom-input>

                                <custom-input
                                    @change="set_value"
                                    datepicker="true"
                                    icon_class="icon icon-calendar"
                                    input_type="datepicker"
                                    allow_input="true"
                                    error_msg="Error! This field is mandatory"
                                    :invalid="errors && errors.includes('birthday')"
                                    :value="person.birthday"
                                    format="dd.mm.yyyy"
                                    name="birthday"
                                    show_reset="true"
                                    type="text"
                                    label="Birthday dd.mm.yyyy"
                                ></custom-input>

                                <dropdown
                                    @selected="set_drop_value"
                                    :value="person.group"
                                    name="group"
                                    label="Set group"
                                    :options="person_group_options"
                                ></dropdown>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-hor">
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('phone')"
                                    :value="person.phone"
                                    limit="20"
                                    icon_class="icon icon-phone icon-inp"
                                    hint="Hint! Max 20 characters"
                                    error_msg="Error! Phone number is not valid"
                                    name="phone"
                                    label="Phone"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    input_type="email"
                                    icon_class="icon icon-envelope icon-inp"
                                    :invalid="errors && errors.includes('email')"
                                    :value="person.email"
                                    limit="60"
                                    hint="Hint! Max 60 characters"
                                    error_msg="Error! E-mail is not valid"
                                    name="email"
                                    label="Email"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    :invalid="errors && errors.includes('facebook')"
                                    :value="person.facebook"
                                    limit="60"
                                    icon_class="icon icon-fb icon-inp"
                                    hint="Hint! Max 60 characters"
                                    error_msg="Error! This field is mandatory"
                                    name="facebook"
                                    label="Facebook"
                                ></custom-input>
                                <dropdown
                                    @selected="set_drop_value"
                                    :value="person.gender"
                                    name="gender"
                                    label="Gender"
                                    :unsort="true"
                                    :options="person_gender_options"
                                ></dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <kids-additional-info-block></kids-additional-info-block>
            </div>
            <div v-else>
                <div class="loading-container">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import customTextarea from "@/components/pages/custom-textarea.vue";
import kidsAdditionalInfoBlock from "./kids-additional-info-block.vue";

export default {
    name: "people-add",
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_person();
            next();
        });
    },
    components: { dropdown, customInput, customTextarea, kidsAdditionalInfoBlock },
    computed: {
        ...mapState("StorePeople", [
            "person",
            "kid",
            "person_group_options",
            "person_gender_options",
            "person_save_btn_loading",
            "errors",
            "kid_errors"
        ])
    },
    data() {
        return {};
    },
    mounted() {},

    methods: {
        ...mapMutations("StorePeople", [
            "clear_person",
            "set_btn_mode",
            "update_field",
            "add_kid",
            "set_person_kid",
            "validate_kid_fields",
            "remove_persons_kid"
        ]),
        set_drop_value(payload) {
            this.update_field({
                prop_name: payload.name,
                prop_value: payload.value
            });
        },
        set_value(args) {
            this.update_field(args);
            if (this.validate_person()) {
                this.set_btn_mode(true);
            } else {
                this.set_btn_mode(false);
            }
        },
        set_empty_person() {
            this.clear_person();
        },
        validate_person() {
            if (this.person.age_group === "adult") {
                if (
                    this.person.first_name &&
                    this.person.first_name.trim() &&
                    this.person.last_name &&
                    this.person.last_name.trim()
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.person.first_name && this.person.first_name.trim()) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
};
</script>
<style scoped>
.btn-default {
    align-self: flex-end;
    margin-left: auto;
    padding: 0.4rem 1.2rem;
}
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
.form-row {
    display: flex;
    padding-bottom: 0;
    padding-top: 0;
}
</style>
